import { render, staticRenderFns } from "./avatar-upload.vue?vue&type=template&id=1e1e8394&scoped=true&"
import script from "./avatar-upload.vue?vue&type=script&lang=js&"
export * from "./avatar-upload.vue?vue&type=script&lang=js&"
import style0 from "./avatar-upload.vue?vue&type=style&index=0&id=1e1e8394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1e8394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1e8394')) {
      api.createRecord('1e1e8394', component.options)
    } else {
      api.reload('1e1e8394', component.options)
    }
    module.hot.accept("./avatar-upload.vue?vue&type=template&id=1e1e8394&scoped=true&", function () {
      api.rerender('1e1e8394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/avatar-upload.vue"
export default component.exports